export const plants = [
  {
    name: "Headquaters",
    areas: [
      {
        name: "Administration",
        units: [{ name: "Floor 1" }, { name: "Floor 2" }]
      },

      {
        name: "Maintenance Services",
        units: [
          { name: "Workshop" },
          { name: "BATHR" },
          { name: "Furnitune" },
          { name: "Evap Units" },
          { name: "LASR" }
        ]
      },

      {
        name: "Factory",
        units: [
          { name: "Roller Station" },
          { name: "CNC Station" },
          { name: "Sawing Station" },
          { name: "Furniture" },
          { name: "Compressor Units" }
        ]
      },

      {
        name: "Exterior - W",
        units: [{ name: "Compressor Units" }]
      },

      {
        name: "Exterior - E",
        units: [{ name: "Parking" }]
      }
    ]
  }
];
